var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "create-task-form" } }, [
    _vm.currentWorkflow
      ? _c(
          "div",
          { staticClass: "status-switcher-wrapper" },
          [
            _c("TicketStatusSwitcher", {
              attrs: {
                "status-list": _vm.pipelineStages,
                "current-status": _vm.currentStage.name,
              },
              on: { "update-status": _vm.handleStageChange },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "task-form" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "input title-input" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.selectWorkflow"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                staticStyle: { width: "100%" },
                attrs: {
                  options: _vm.workflowOptions,
                  placeholder: _vm.$t("task.selectWorkflow"),
                },
                on: { change: _vm.bindData },
                model: {
                  value: _vm.form.workflowId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "workflowId", $$v)
                  },
                  expression: "form.workflowId",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "input title-input" },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("task.title"))),
            ]),
            _vm._v(" "),
            _c("a-input", {
              staticClass: "classic-new-input",
              attrs: { placeholder: _vm.$t("task.taskNumber") },
              model: {
                value: _vm.form.title,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "title", $$v)
                },
                expression: "form.title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input priority-input" },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("task.priority"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "classic-new-select",
                model: {
                  value: _vm.form.priority,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "priority", $$v)
                  },
                  expression: "form.priority",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "low" } }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", gap: "5px" } },
                    [
                      _c("LowIcon", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-top": "3px",
                        },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.low")) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "lowest" } }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", gap: "5px" } },
                    [
                      _c("LowestIcon", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-top": "3px",
                        },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.lowest")) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "medium" } }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", gap: "5px" } },
                    [
                      _c("MediumIcon", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-top": "3px",
                        },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.medium")) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "high" } }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", gap: "5px" } },
                    [
                      _c("HighIcon", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-top": "3px",
                        },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.high")) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "highest" } }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", gap: "5px" } },
                    [
                      _c("HighestIcon", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-top": "3px",
                        },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.highest")) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("quill-editor", {
            staticClass: "quill-editor",
            staticStyle: { "max-height": "20%", width: "100%" },
            attrs: {
              options: _vm.editorOption,
              placeholder: _vm.$t("auto.createTaskDesc"),
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "checklist-data" }, [
          _vm.form.checklist.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "20px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                        "margin-right": "20px",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("auto.checklist")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "200px" } },
                    [
                      _c("a-progress", {
                        attrs: {
                          "stroke-color": {
                            "0%": "ec4b1d",
                            "100%": "ec4b1d",
                          },
                          percent:
                            (100 / _vm.form.checklist.length) *
                            _vm.form.checklist.filter(function (c) {
                              return c.isCompleted
                            }).length,
                          "show-info": false,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "200px" } }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("task.completedOfCheck", {
                            total: _vm.form.checklist.length,
                            completed: _vm.form.checklist.filter(function (c) {
                              return c.isCompleted
                            }).length,
                          })
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "10px",
                display: "flex",
                gap: "10px",
                "flex-direction": "column",
              },
            },
            _vm._l(_vm.form.checklist, function (checkbox, index) {
              return _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "flex-start",
                    "user-select": "none",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "10px",
                      },
                    },
                    [
                      _c("a-checkbox", {
                        staticClass: "kanban-checkbox large",
                        model: {
                          value: checkbox.isCompleted,
                          callback: function ($$v) {
                            _vm.$set(checkbox, "isCompleted", $$v)
                          },
                          expression: "checkbox.isCompleted",
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: checkbox.title,
                            expression: "checkbox.title",
                          },
                        ],
                        staticStyle: {
                          width: "300px",
                          border: "none",
                          outline: "none",
                          background: "#f1f1f1",
                          "border-radius": "4px",
                          padding: "3px 10px",
                        },
                        domProps: { value: checkbox.title },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(checkbox, "title", $event.target.value)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "material-icons",
                      on: {
                        click: function ($event) {
                          return _vm.deleteCheckbox(index)
                        },
                      },
                    },
                    [_vm._v("close")]
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "10px",
                color: "#ec4b1d",
                "font-weight": "bold",
                cursor: "pointer",
              },
              on: { click: _vm.addNewCheckBox },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    !_vm.form.checklist.length
                      ? this.$t("task.newCheckList")
                      : this.$t("task.add")
                  ) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "attachments-section" }, [
        _vm.attachmentFileVisible
          ? _c(
              "div",
              {
                staticClass: "row",
                staticStyle: { cursor: "pointer" },
                on: { click: _vm.openFileInput },
              },
              [
                _c("div", { staticClass: "attach-files" }, [
                  _c("div", { staticClass: "text" }, [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("attachment"),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.$t("mail.attacheFiles")))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "logo" }, [_c("s3Logo")], 1),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticStyle: { display: "none" },
                  attrs: { id: "fileInput", type: "file" },
                  on: { change: _vm.uploadFile },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.attachmentsUploading
          ? _c("div", { staticClass: "attachments-loading-overlay" }, [
              _c("div", { staticClass: "attachments-loading-content" }, [
                _c("div", { staticClass: "attachments-spinner" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.uploadingFile")))]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row attachments-row",
            staticStyle: { display: "grid", gap: "20px" },
          },
          _vm._l(_vm.form.attachments, function (attachment) {
            return _c(
              "div",
              {
                key: attachment.id || attachment._id,
                staticClass: "attach-files-visibility",
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      attachment.v2Format && attachment.cdnUrl
                        ? attachment.cdnUrl
                        : "https://static.supsis.live/" +
                          (attachment.path + attachment.id) +
                          "." +
                          attachment.ext,
                    alt: attachment.name,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "image-content" }, [
                  _c("div", { staticClass: "text" }, [
                    _vm.editImageName === attachment.id
                      ? _c(
                          "div",
                          { staticClass: "edit-img-name" },
                          [
                            _c("a-input", {
                              attrs: { type: "text" },
                              model: {
                                value: attachment.name,
                                callback: function ($$v) {
                                  _vm.$set(attachment, "name", $$v)
                                },
                                expression: "attachment.name",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("label", [_vm._v(_vm._s(attachment.name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.updatedAtFormated(attachment.createdDate)) +
                        "\n                            "
                    ),
                    _c("div", { staticClass: "edit-btn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "underline",
                          on: {
                            click: function ($event) {
                              return _vm.deleteAttachment(attachment.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("chatbotv2.delete")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n                                |\n                                "
                      ),
                      _vm.attachmentEditVisible
                        ? _c(
                            "div",
                            {
                              staticClass: "underline",
                              on: {
                                click: function ($event) {
                                  return _vm.editImageNameFunc(attachment.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.$t("settings.edit")) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n                                |\n                                "
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "underline",
                          on: {
                            click: function ($event) {
                              return _vm.openImage(attachment._id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("task.view")) +
                              "\n                                "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "a-modal",
                  {
                    attrs: {
                      id: "task-attachment-image",
                      visible: _vm.taskAttachmentsImgVisible,
                      footer: false,
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.taskAttachmentsImgVisible = false
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.selectedImage.url,
                        alt: _vm.selectedImage.name,
                      },
                    }),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-assigne" }, [
        _c("div", { staticClass: "input", staticStyle: { width: "100%" } }, [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.assignee"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user-assigne-container" },
            [
              _c("a-select", {
                staticClass: "select-multiple",
                attrs: {
                  mode: "multiple",
                  options: _vm.visibilityUsers,
                  "filter-option": _vm.filterOption,
                },
                model: {
                  value: _vm.form.assigneeIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "assigneeIds", $$v)
                  },
                  expression: "form.assigneeIds",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "assigne-user-options" }, [
                _c(
                  "div",
                  {
                    staticClass: "assigne-option",
                    on: {
                      click: function ($event) {
                        return _vm.openAssigne("owner")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("task.owner")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "assigne-option",
                    on: {
                      click: function ($event) {
                        return _vm.openAssigne("collaborators")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("task.collaborators")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "assigne-option",
                    on: {
                      click: function ($event) {
                        return _vm.openAssigne("followers")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("task.followers")) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "input user-assigne-owner",
            staticStyle: { width: "100%" },
            style: { height: _vm.assigneOptions["owner"] ? "95px" : "0px" },
          },
          [
            _c("div", { staticClass: "row-bracket" }),
            _vm._v(" "),
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("task.owner"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "user-assigne-container" },
              [
                _c("a-select", {
                  staticClass: "select-multiple",
                  attrs: { options: _vm.visibilityUsers },
                  model: {
                    value: _vm.form.ownerId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "ownerId", $$v)
                    },
                    expression: "form.ownerId",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "input user-assigne-collaborators",
            staticStyle: { width: "100%" },
            style: {
              height: _vm.assigneOptions["collaborators"] ? "95px" : "0px",
            },
          },
          [
            _c("div", { staticClass: "row-bracket" }),
            _vm._v(" "),
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("task.collaborators"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "user-assigne-container" },
              [
                _c("a-select", {
                  staticClass: "select-multiple",
                  attrs: {
                    mode: "multiple",
                    options: _vm.visibilityUsers,
                    "filter-option": _vm.filterOption,
                  },
                  model: {
                    value: _vm.form.collaboratorIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "collaboratorIds", $$v)
                    },
                    expression: "form.collaboratorIds",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "input user-assigne-followers",
            staticStyle: { width: "100%" },
            style: { height: _vm.assigneOptions["followers"] ? "95px" : "0px" },
          },
          [
            _c("div", { staticClass: "row-bracket" }),
            _vm._v(" "),
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("task.followers"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "user-assigne-container" },
              [
                _c("a-select", {
                  staticClass: "select-multiple",
                  attrs: {
                    mode: "multiple",
                    options: _vm.visibilityUsers,
                    "filter-option": _vm.filterOption,
                  },
                  model: {
                    value: _vm.form.followerIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "followerIds", $$v)
                    },
                    expression: "form.followerIds",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "input" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("message.startDate"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("a-date-picker", {
                attrs: { dropdownClassName: "task-date-picker" },
                model: {
                  value: _vm.form.startDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startDate", $$v)
                  },
                  expression: "form.startDate",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input" }, [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("message.endDate"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("a-date-picker", {
                attrs: { dropdownClassName: "task-date-picker" },
                model: {
                  value: _vm.form.endDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "endDate", $$v)
                  },
                  expression: "form.endDate",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row-bracket" }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "checklist-data" }, [
          _vm.form.subTasks.filter(function (c) {
            return c.isCompleted && !c.isExits
          }).length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "20px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                        "margin-right": "20px",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("task.subTasks")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "200px" } },
                    [
                      _c("a-progress", {
                        attrs: {
                          "stroke-color": {
                            "0%": "ec4b1d",
                            "100%": "ec4b1d",
                          },
                          percent:
                            (100 / _vm.form.subTasks.length) *
                            _vm.form.subTasks.filter(function (c) {
                              return c.isCompleted
                            }).length,
                          "show-info": false,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "200px" } }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("task.completedOfCheck", {
                            total: _vm.form.subTasks.filter(function (c) {
                              return c.isCompleted && !c.isExits
                            }).length,
                            completed: _vm.form.subTasks.filter(function (c) {
                              return c.isCompleted
                            }).length,
                          })
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.subTasks.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    display: "flex",
                    gap: "10px",
                    "flex-direction": "column",
                  },
                },
                _vm._l(_vm.form.subTasks, function (subtask, index) {
                  return _c("div", [
                    !subtask.isExits
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                              "user-select": "none",
                              gap: "20px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "10px",
                                  width: "100%",
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "kanban-checkbox large",
                                  model: {
                                    value: subtask.completed,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "completed", $$v)
                                    },
                                    expression: "subtask.completed",
                                  },
                                }),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticClass: "classic-new-input",
                                  attrs: {
                                    placeholder: _vm.$t("task.subtaskTitle"),
                                  },
                                  model: {
                                    value: subtask.title,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "title", $$v)
                                    },
                                    expression: "subtask.title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("a-select", {
                                  staticClass: "select-multiple",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.visibilityUsers,
                                    placeholder: _vm.$t("task.assignee"),
                                  },
                                  model: {
                                    value: subtask.assignees,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "assignees", $$v)
                                    },
                                    expression: "subtask.assignees",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSubtask(index)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                              "user-select": "none",
                              gap: "20px",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("a-select", {
                                  staticClass: "select-multiple",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    options: _vm.visibilityUsers,
                                    placeholder: _vm.$t("task.assignee"),
                                  },
                                  model: {
                                    value: subtask.taskId,
                                    callback: function ($$v) {
                                      _vm.$set(subtask, "taskId", $$v)
                                    },
                                    expression: "subtask.taskId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSubtask(index)
                                  },
                                },
                              },
                              [_vm._v("close")]
                            ),
                          ]
                        ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "10px",
                  color: "#ec4b1d",
                  "font-weight": "bold",
                  cursor: "pointer",
                },
                on: {
                  click: function ($event) {
                    return _vm.addNewSubtask(false)
                  },
                },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("task.addSubtask")) +
                    "\n                    "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "add-tags ml-2 mt-4" }, [
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "10px",
                color: "#ec4b1d",
                "font-weight": "bold",
                cursor: "pointer",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("message.addTag")) +
                  "\n                    "
              ),
              _c(
                "a-dropdown",
                [
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "10px", padding: "2px" } },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    _vm._l(_vm.tags, function (tag) {
                      return _c(
                        "a-menu-item",
                        {
                          key: tag._id,
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectTag(tag)
                            },
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "showColor",
                            style: {
                              backgroundColor: tag.color,
                              width: "20px",
                              height: "20px",
                              borderRadius: "5px",
                              marginRight: "8px",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(tag.name))]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.tags.length > 0
            ? _c(
                "div",
                { staticClass: "selected-tags" },
                _vm._l(_vm.form.tags, function (tag) {
                  return _c(
                    "div",
                    {
                      key: tag._id,
                      staticClass: "tag-item",
                      style: _vm.getTagStyle(tag.color),
                    },
                    [
                      _c("span", [_vm._v(_vm._s(tag.name))]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "material-icons close-icon",
                          on: {
                            click: function ($event) {
                              return _vm.removeTag(tag._id)
                            },
                          },
                        },
                        [_vm._v("close")]
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }